/** Operators need to prepare machines that will be producing parts through the night.
 * Work counter and tool change tasks need to be done before the end of the working day.
 * Tasks that are targeted for the evening or night are shown early and tasks that are targeted
 * for the night are highlighted.
 */

import { DateTime } from 'luxon';
import { AutoTask } from '../types/autoTask.js';


const EVENING_START_HOUR = 18;

export function showNightTasks(): boolean {
    const currentTime = DateTime.now().setZone('Europe/Helsinki');
    return currentTime.hour >= EVENING_START_HOUR;// Only the evening matters, we can ignore after midnight.
}

export function isTaskThisNight(task: Pick<AutoTask, 'targetTime'>): boolean {
    const currentHour = DateTime.now().setZone('Europe/Helsinki').set({ minute: 0, second: 0, millisecond: 0 });
    const thisNightStart = currentHour.set({ hour: 22 }).toJSDate();
    const thisNightEnd = currentHour.plus({ days: 1 }).set({ hour: 6 }).toJSDate();

    // Only the evening matters, so after midnight we can already look at the next night.
    return task.targetTime >= thisNightStart && task.targetTime < thisNightEnd;
}

export function isTaskThisEvening(task: Pick<AutoTask, 'targetTime'>): boolean {
    const currentHour = DateTime.now().setZone('Europe/Helsinki').set({ minute: 0, second: 0, millisecond: 0 });
    const thisEveningStart = currentHour.set({ hour: EVENING_START_HOUR }).toJSDate();
    const thisEveningEnd = currentHour.set({ hour: 22 }).toJSDate();

    // Only the evening matters, so after midnight we can already look at the next night.
    return task.targetTime >= thisEveningStart && task.targetTime < thisEveningEnd;
}

